import React, { useEffect } from 'react';
import { View, ScrollView } from 'react-native';
import { Card, Colors } from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';
import Icon from 'react-native-vector-icons/Ionicons';

import { Header } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { getClassSummary } from '../../../redux/actions/companyActions';
import styles from './styles';

export default function reportClasses({ navigation }) {
  const dispatch = useDispatch();
  const { companyData, classSummary } = useSelector((state) => state.company);
  useEffect(() => {
    dispatch(getClassSummary(companyData.id_empresa));
  }, []);
  const renderStars = (stars) => {
    const final = [];
    for (let i = 0; i < 5; i++) {
      final.push(i < stars ? '+' : '-');
    }
    return (
      <View style={styles.viewStars}>
        {final.map((item) => (
          <Icon key={`star-${Math.random()}`} name={`star${item === '-' ? '-outline' : ''}`} style={[styles.iconStar, { color: item === '+' ? Colors.yellow500 : Colors.black }]} />
        ))}
      </View>
    );
  };
  return (
    <>
      <Header navigation={navigation} profilePic={companyData.foto} userName={companyData.nome} />

      <ScrollView>
        <View style={styles.container}>
          <AppText style={styles.textHeader}>Relatório Aulas</AppText>
          <View style={styles.viewEvaluation}>
            <Card style={styles.card}>
              <AppText style={styles.titleCard}>Avaliação Geral — Colaboradores</AppText>
              <View style={styles.cardStars}>
                <AppText style={styles.textTheme}>Profissional</AppText>
                { renderStars(classSummary.nota_profissional) }
                <AppText style={styles.textTheme}>Aulas</AppText>
                { renderStars(classSummary.nota_aula) }
              </View>
              {
                /**
                 *
                 <View style={styles.viewChart}>
                   <ProgressCircle
                     style={{ height: pixelDimensions(20) }}
                     animate
                     progress={0.9}
                     progressColor="rgb(134, 65, 244)"
                     startAngle={0}
                   />
                   <Text style={styles.textChart}>90% Adesão</Text>
                 </View>
                 *
                 */
              }
            </Card>

            {/* <Card style={styles.card}>
              <AppText style={styles.titleCard}>Análise Profissional</AppText>
              <View style={styles.cardStars}>
                <AppText style={styles.textTheme}>Dificuldades para realizações dos exercícios durante a aula</AppText>
                { renderStars(classSummary.nota_dificuldade) }
                <AppText style={styles.textTheme}>Qualidade da Internet — Aulas</AppText>
                { renderStars(classSummary.nota_qualidade) }
              </View>
            </Card> */}

          </View>

          <AppButton
            size="bold"
            label="VOLTAR"
            rippleColor={Colors.white}
            style={styles.buttonBack}
            labelStyle={styles.textBack}
            onPress={() => navigation.goBack()}
          />
        </View>
      </ScrollView>
    </>
  );
}
